import { TreatmentType } from 'app/core/enums';

/**
 * Product card and filter order: Moment, Neer, Crystal, Night Guard.
 */
export const TreatmentTypeConfig: TreatmentType[] = [
  TreatmentType.Moment,
  TreatmentType.Veneers,
  TreatmentType.NeerCrystal,
  TreatmentType.NightGuard,
];

/**
 * Sorts treatment types by the New Order product display sequence.
 */
export function compareTreatmentTypeDisplayOrder(leftId: number, rightId: number): number {
  return TreatmentTypeConfig.indexOf(leftId) - TreatmentTypeConfig.indexOf(rightId);
}
